import { SEO } from "@/components/SEO";
import { PageHero } from "@/components/PageHero";
import pebaImg from "@/assets/peba-gradara.jpg";
import balneareImg from "@/assets/progettazione-balneare.jpg";
import { CheckCircle2 } from "lucide-react";

const services = [
  "Mappatura accessibilità di spazi urbani",
  "Audit di condomini e uffici",
  "Strutture turistiche ricettive",
  "Stabilimenti balneari accessibili",
  "Modelli operativi per P.E.B.A.",
  "Consulenza per Amministrazioni comunali",
];

const AreaTecnica = () => (
  <>
    <SEO
      title="Area Tecnica — FIABA ETS"
      description="Mappatura dell'accessibilità di spazi urbani, condomini, uffici, strutture turistiche, stabilimenti balneari. Modelli P.E.B.A. per Amministrazioni comunali."
      path="/area-tecnica"
    />
    <PageHero
      eyebrow="Area Tecnica"
      title="Soluzioni concrete per spazi accessibili"
      subtitle="Individuiamo modelli operativi attuabili per garantire una corretta vivibilità a ogni individuo."
    />
    <section className="section-padding">
      <div className="container-narrow grid lg:grid-cols-2 gap-12 items-start">
        <div className="space-y-5 text-foreground/90 leading-relaxed">
          <p>L'Area Tecnica di FIABA <strong>mappa l'accessibilità degli spazi urbani</strong>, dei condomini, degli uffici, delle strutture turistiche ricettive e degli stabilimenti balneari, individuando soluzioni concrete e attuabili per garantire una corretta vivibilità a ogni individuo.</p>
          <p>Alle Amministrazioni comunali proponiamo modelli operativi per la redazione dei <strong>P.E.B.A. – Piani di Eliminazione delle Barriere Architettoniche</strong>, adottando un modello da noi elaborato, semplice, efficace e facilmente realizzabile.</p>
          <ul className="grid sm:grid-cols-2 gap-3 mt-6">
            {services.map((s) => (
              <li key={s} className="flex items-start gap-2 text-sm">
                <CheckCircle2 className="w-5 h-5 text-secondary shrink-0 mt-0.5" />
                <span>{s}</span>
              </li>
            ))}
          </ul>
        </div>
        <div className="space-y-4">
          <img src={pebaImg} alt="P.E.B.A. del Comune di Gradara" className="rounded-lg shadow-elegant w-full" loading="lazy" />
          <img src={balneareImg} alt="Progetto stabilimento balneare accessibile al tramonto" className="rounded-lg shadow-elegant w-full" loading="lazy" />
        </div>
      </div>
    </section>
  </>
);

export default AreaTecnica;
